import EbisSingleDatePicker from 'views/molecules/single-date-picker/EbisSingleDatePicker';

export default EbisSingleDatePicker;
